import { render } from "./FooterMain.vue?vue&type=template&id=4584a921&scoped=true"
import script from "./FooterMain.vue?vue&type=script&lang=js"
export * from "./FooterMain.vue?vue&type=script&lang=js"

import "./FooterMain.vue?vue&type=style&index=0&id=4584a921&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4584a921"

export default script